// TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/22954
export const PATTERN = {
  ESPECIAL_CHARACTER: /^[^$%&|/<>()#!¡¿?'^:]*$/,
  REGEX_WITHOUT_SPACES: /^[^$%&|/<>()#!¡¿?'^:\s]*$/,
  REPLACE_CHARACTERS_SPECIALS:  /[*+?<>^${}()|[\]\\]/g,
  NUMBERS: /^[0-9]+$/,
  // number with two decimal places and greater than zero. does not allow starting with zero and a point is used in the decimal
  // example: 234234.11
  DECIMAL_WITHOUT_ZERO: /^[1-9][0-9]*([/.][0-9])?[0-9]?$/,
  // alphabetic character that can be separated by a space, does not allow starting or ending with a space or consecutive spaces
  // example: pay valida sas
  CHARACTERS_SPACE_CHARACTERS: /^(?! )(?![\s\S]* $)[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/,
  PATTERN_ONLY_TWO_DECIMAL: /^[0-9]+([.][0-9]{1,2})?$/,
  REGEX_FORMAT_IMG: /(?:\.([^.]+))?$/,
  VALID_DI: /^([0-9]+-{1}[0-9]{1})$/i
};
